import { pickBy } from "lodash";
import { SERVICE_ITEM_TYPE_ENUM } from "@/enums/gmb-services.enum";
import cuid from "cuid";
export default class PayloadManager {
  static getServiceItemsPayload(action, serviceItem) {
    const item = this.createServiceItem(serviceItem);
    return {
      action,
      item
    };
  }

  static getItemBaseFields(item) {
    const { price, description, currency_code } = item;
    return pickBy({
      id: item.id,
      description,
      price,
      currency_code
    });
  }

  static getStructuredItem(item) {
    return {
      ...this.getItemBaseFields(item),
      gmb_service_type: item.gmb_service_type,
      type: SERVICE_ITEM_TYPE_ENUM.STRUCTURED
    };
  }

  static getFreeFormItem(item) {
    return {
      ...this.getItemBaseFields(item),
      display_name: item.display_name,
      gmb_category: item.gmb_category,
      type: SERVICE_ITEM_TYPE_ENUM.FREE_FORM
    };
  }

  static createServiceItem(item) {
    if (item.gmb_service_type && item.gmb_service_type.service_type_id) {
      return this.getStructuredItem(item);
    } else {
      return this.getFreeFormItem(item);
    }
  }
}
